import React from "react";
import { Link } from 'react-router-dom';
import { Offline, Online } from "react-detect-offline";
import firebase from '../Firebase';
import moment from 'moment';
import Sidebar from "react-sidebar";
import profile_photo from '../users/profiles/child_avatar.png';
 
class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: true
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }
 
  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  noConnection = () => {
    alert("No Internet connection");
  }
 
  render() {
      var { showSideBar, logout, photo, User, Child, age, Translator } = this.props;
      const { years, months, days} = age;
      const { user_name } = User;
      const { first_name, last_name, settlement } = Child;
      var { birth_date, sex, twin_sibling } = Child;
      birth_date = moment(new Date(birth_date));
      birth_date = birth_date.format("MMM Do YYYY");
      const translation = Translator;
      sex = sex === 'M' ? translation['male_sex'] : translation['female_sex'];
      twin_sibling = twin_sibling === 'Yes' ? translation['yes_option'] : translation['no_option'];

      photo = photo === null ? profile_photo : photo;

    return (
      <Sidebar
        sidebar={

          <div className="sidebar" id="sidebar" style = {{backgroundColor: "#fff",overflow: "scroll"}}>
            <Online><div onClick={showSideBar} className="user" style={{textAlign: "center",fontSize: "5em",padding:"20px 0px",background: "#ccc",color: "#000"}}><Link to={`${process.env.PUBLIC_URL}/dashboard/change-photo/`}><img src={photo} style={{height: "100px",width: "100px",borderRadius: "50%"}} /></Link></div></Online>
            <Offline><div onClick={this.noConnection} className="user" style={{textAlign: "center",fontSize: "5em",padding:"20px 0px",background: "#ccc",color: "#000"}}><img src={profile_photo} style={{height: "100px",width: "100px",borderRadius: "50%"}} /></div></Offline>
            <ul className="list" style={{padding:"0px 20px",listStyle: "none",lineHeight: "55px"}}>
              <li>{translation['dashboard_child_name_label']}: <b>{first_name+' '+last_name}</b></li>
              {translation['language'] === 'swahili' ? (
                  <li>{translation['dashboard_child_age_label']}: miaka <b>{years}</b>, miezi <b>{months}</b> na siku <b>{days}</b></li>
              ) : (
                  <li>{translation['dashboard_child_age_label']}: <b>{years}</b> Yr(s), <b>{months}</b> Mon(s) and <b>{days}</b> Day(s)</li>
              )}
              <li>{translation['dashboard_child_dob_label']}: <b>{birth_date}</b></li>
              <li>{translation['dashboard_child_sex_label']}: <b>{sex}</b></li> 
              <li>{translation['dashboard_child_residence_label']}: <b>{settlement}</b></li>  
              <li>{translation['dashboard_child_twin_sibling_status_label']}: <b>{twin_sibling}</b></li>
              <li onClick={showSideBar}><Link to={`${process.env.PUBLIC_URL}/dashboard/change-password/`} style={{fontSize: "0.9em"}}>{translation['dashboard_change_password_label']}</Link></li> 
              <li><Link onClick={logout} to={`#`} style={{fontSize: "0.9em"}}>{translation['dashboard_logout_label']}</Link></li>   
            </ul> 
            </div>

        }
        open={this.state.sidebarOpen}
        onSetOpen={showSideBar}
        styles={{ sidebar: { background: "white" } }}
      >
        {/* <button onClick={() => this.onSetSidebarOpen(true)}>
          Open sidebar
        </button> */}
      </Sidebar>
    );
  }
}
 
export default SideBar;